import React, { useState } from 'react';
import { Alert, Button, Card, Form, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../LoginForm/styles.css';

const SignUpForm = ({ onSubmit, isLoading, alert, onAlertClose }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastName] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        setError('');
        onSubmit({ email, password, firstname, lastname });
    };

    return (
        <Card className="login-card shadow-sm">
            <Card.Header>
                <h5 className="app-name">FitOps</h5>
            </Card.Header>
            <Card.Body>
                {error && (
                    <Alert variant="danger" dismissible onClose={() => setError('')}>
                        {error}
                    </Alert>
                )}
                {alert && alert.show && (
                    <Alert variant={alert.variant} dismissible onClose={onAlertClose}>
                        {alert.message}
                    </Alert>
                )}
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="formGivenName">
                                <Form.Label>First name</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={firstname}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    placeholder="First"
                                    autoComplete="given-name"
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="formFamilyName">
                                <Form.Label>Last name</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={lastname}
                                    onChange={(e) => setLastName(e.target.value)}
                                    placeholder="Last"
                                    autoComplete="family-name"
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            autoComplete="email"
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="new-password"
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formConfirmPassword">
                        <Form.Label>Confirm password</Form.Label>
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="new-password"
                            required
                        />
                    </Form.Group>
                    <Button type="submit" className="w-100 login-submit-btn" disabled={isLoading}>
                        {isLoading ? 'Creating account…' : 'Create Account'}
                    </Button>
                </Form>
            </Card.Body>
            <Card.Footer>
                <span>Already have an account? <Link to="/login">Log in</Link></span>
            </Card.Footer>
        </Card>
    );
};

export default SignUpForm;
